import axios from "axios";

const state = {
    TransferDialog:false,
    TransferDialogSuccess:false,
    holderName:'',
    PersonalDialog:false
};

const getters = {
    getPersonalDialog(state){
        return state.PersonalDialog
    },    
getTransferDialog(state){
      return state.TransferDialog
  },
getTransferDialogSuccess(state){
    return state.TransferDialogSuccess
    },
getholderName(state){
        return state.holderName
    }
};

const mutations = {
    setTransferDialog(state, payload) {
    state.TransferDialog = payload;
  },
  setTransferDialogSuccess(state, payload) {
    state.TransferDialogSuccess = payload;
  },
  setholderName(state, payload) {
    state.holderName = payload;
  },
  setPersonalDialog(state, payload) {
    state.PersonalDialog = payload;
  }
};

const actions = {
    verifyAccount({commit}, payload){
    commit("setTransferDialog", false);
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/BankAccountValidationRequest?bankID=${payload.bankcode}&accountNumber=${payload.AccountNumber}`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setTransferDialogSuccess", true);
            commit("setholderName", res.data.holderName);

        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
        commit("setTransferDialog", true);
      })
  },

  ConfirmPayment({commit}, payload){
    commit("setTransferDialog", false);
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/BankTransferRequest?customerID=${payload.customerID}&pin=${payload.pin}&bankID=${payload.bankcode}&bankAccountId=${payload.AccountNumber}&amount=${payload.amount * 100}&withdrawAccountType=${payload.withdrawAccountType}&location='WEBSITE'&imei='WEBSITE'`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setTransferDialogSuccess", false);
            commit("setBalance",  res.data.updatedMainBalance );
            commit("setCommissionBalance",  res.data.updatedCommissionBalance );
            commit("setTransferDialog", false);
            commit("setSnackbar", true);
            commit("setServerMessage", "Successful")
            payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
            commit("setTransferDialogSuccess", false);
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  Transfer({commit}, payload){
    commit("setPersonalDialog", false);
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/PersonalTransferRequest?customerID=${payload.customerID}&pin=${payload.pin}&accountFrom=COMMISSION&accountTo=MAIN&amount=${payload.amount * 100}&imei=1234567890`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setBalance",  res.data.updatedMainBalance );
            commit("setSnackbar", true);
            commit("setServerMessage", "Successful")
            commit("setCommissionBalance",  res.data.updatedCommissionBalance );
            payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
            commit("setPersonalDialog", true);
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
        commit("setPersonalDialog", true);
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};








